import type { Employee } from '../../types/employee';
import type { RegulatoryRates } from '../../types/regulatoryRates';
import { businessIncomeWithLocalFromRegulatory } from './types';

/** Flutter `calculateInsuranceAmount` 일당 8일↑ 경로 — 1:1 */
export function calculateFullWorkerInsurance(
  employee: Employee,
  totalSalary: number,
  rates: RegulatoryRates,
): number {
  if (!employee.hasFourInsurance) {
    const combined = businessIncomeWithLocalFromRegulatory(rates);
    return Math.round(totalSalary * combined);
  }

  const nps = rates.socialInsurance?.nps?.workerShare ?? 0.0475;
  const nhi = rates.socialInsurance?.nhi?.employerShare ?? 0.03595;
  const ltc = rates.socialInsurance?.nhi?.ltcRateOfNhi ?? 0.1281;
  const ei = rates.socialInsurance?.ei?.unemployment?.worker ?? 0.009;

  const pension = Math.round(totalSalary * nps);
  const health = Math.round(totalSalary * nhi);
  const longTerm = Math.round(health * ltc);
  const employment = Math.round(totalSalary * ei);

  return pension + health + longTerm + employment;
}
